import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "form-dialog__title",
  style: {"margin":"0 0 10px"}
}, "客户开票信息", -1)

import { withDefaults, ref, watchEffect } from 'vue';
import {
  BaseTable,
  BaseTableProps,
  useTableColumn,
  BaseButton,
  BaseInput,
  XrkMessage
} from 'xrk-components';
import { BasicInformationData } from '@V/invoice/src/data-source/types';
import { modifyIndustry } from '@V/invoice/src/data-source/apis';

type ClientList = BasicInformationData['clientList'];


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-enterprise-dialog-client',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } },
    value: {}
  },
  setup(__props: any) {

const props = __props;

const formData = ref<ClientList>(props.value);
const editIndex = ref(-1); // 当前编辑下标

watchEffect(() => {
  formData.value = props.value;
});

const isCurIndex = (index: number) => editIndex.value === index;

const columns: BaseTableProps['columns'] = [
  useTableColumn({
    type: 'index',
    label: '序号',
    width: '80px',
    fixed: 'left'
  }),
  useTableColumn({
    label: '企业名称',
    prop: 'industryEnterpriseName'
  }),
  useTableColumn({
    label: '社会统一社会信用代码',
    prop: 'industryEnterpriseIdentifierNo',
    render({ row, index, cellValue }) {
      return isCurIndex(index) ? (
        <BaseInput type="text" v-model={row.industryEnterpriseIdentifierNo} />
      ) : (
        <span>{cellValue}</span>
      );
    }
  }),
  useTableColumn({
    label: '联系方式',
    prop: 'enterprisePhone',
    render({ row, index, cellValue }) {
      return isCurIndex(index) ? (
        <BaseInput type="tel" v-model={row.enterprisePhone} />
      ) : (
        <span>{cellValue}</span>
      );
    }
  }),
  useTableColumn({
    label: '开户银行',
    prop: 'openBank',
    render({ row, index, cellValue }) {
      return isCurIndex(index) ? (
        <BaseInput type="text" v-model={row.openBank} />
      ) : (
        <span>{cellValue}</span>
      );
    }
  }),
  useTableColumn({
    label: '银行账号',
    prop: 'bankNo',
    render({ row, index, cellValue }) {
      return isCurIndex(index) ? (
        <BaseInput type="text" v-model={row.bankNo} />
      ) : (
        <span>{cellValue}</span>
      );
    }
  }),
  useTableColumn({
    label: '公司地址',
    prop: 'industryEnterpriseAddress',
    render({ row, index, cellValue }) {
      return isCurIndex(index) ? (
        <BaseInput type="text" v-model={row.industryEnterpriseAddress} />
      ) : (
        <span>{cellValue}</span>
      );
    }
  }),
  useTableColumn({
    label: '收件人',
    prop: 'receiveName',
    render({ row, index, cellValue }) {
      return isCurIndex(index) ? (
        <BaseInput type="text" v-model={row.receiveName} />
      ) : (
        <span>{cellValue}</span>
      );
    }
  }),
  useTableColumn({
    label: '联系方式',
    prop: 'receivePhone',
    render({ row, index, cellValue }) {
      return isCurIndex(index) ? (
        <BaseInput type="tel" v-model={row.receivePhone} />
      ) : (
        <span>{cellValue}</span>
      );
    }
  }),
  useTableColumn({
    label: '邮寄地址',
    prop: 'mailAddress',
    render({ row, index, cellValue }) {
      return isCurIndex(index) ? (
        <BaseInput type="text" v-model={row.mailAddress} />
      ) : (
        <span>{cellValue}</span>
      );
    }
  }),
  useTableColumn({
    label: '操作',
    fixed: 'right',
    render: ({ index, row }) => {
      return (
        <>
          <BaseButton
            type="text"
            disabled={!(editIndex.value === -1 || isCurIndex(index))} // -1都可点击，进入编辑后只有当前的行可操作
            click={async () => {
              // 保存
              if (isCurIndex(index)) {
                // 保存完成后初始下标
                editIndex.value = -1;
                await modifyIndustry(row);
                XrkMessage.success('操作成功');
                return;
              }
              // 进入编辑
              editIndex.value = index;
            }}
          >
            {isCurIndex(index) ? '保存' : '编辑'}
          </BaseButton>
        </>
      );
    }
  })
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_unref(BaseTable), {
      columns: columns,
      data: formData.value,
      height: 400
    }, null, 8, ["data"])
  ]))
}
}

})